/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-title-margin-bottom',
  templateUrl: './theme-option-tooltips-title-margin-bottom.component.html',
  styleUrls: ['./theme-option-tooltips-title-margin-bottom.component.css']
})
export class ThemeOptionTooltipsTitleMarginBottomComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_titleMarginBottom';

  constructor() {}

  receiveValue(value: string) {
    this.themeOptions.setOption('tooltips_titleMarginBottom', value);
  }

}
